export default __webpack_public_path__ + "static/3-e1e6ab7dc1e1293fa93cca1f21e7f52f.jpeg";